module.exports = __webpack_public_path__ + "img/sortImg1-5.291d352a.png";